import { cn } from "@/frontend/algolia/utils/cn";
import React from "react";

interface CalloutHeroProps {
  backgroundImage?: string;
  backgroundImageAlt?: string;
  title?: string;
  description?: string;
  ctaText?: string;
  ctaHref?: string;
}

const CalloutHero: React.FC<CalloutHeroProps> = ({
  backgroundImage = null,
  backgroundImageAlt = "",
  title = null,
  description = null,
  ctaText = null,
  ctaHref = null,
}) => {
  if (!backgroundImage && !title && !description && !ctaText && !ctaHref) {
    return null;
  }

  return (
    <article
      className={cn(
        "tw-py-28 tw-px-6 md:tw-p-0 md:tw-h-[336px]",
        "tw-flex tw-justify-center tw-items-center",
        backgroundImage && "tw-relative [&>img]:tw-absolute [&>img]:tw-inset-0 [&>img]:tw-w-full [&>img]:tw-h-full [&>img]:tw-object-cover [&>img]:tw-z-0",
      )}
    >
      {backgroundImage  && (
        <img
          src={backgroundImage}
          alt={backgroundImageAlt}
          className="tw-opacity-50"
        />
      )}

      {/* Content */}
      <div
        className={cn(
          "tw-max-w-md tw-text-center tw-relative tw-z-10",
          "[&>p]:tw-mt-6 [&>a]:tw-mt-5"
        )}
      >
        <h2 className="tw-text-2xl tw-line-clamp-2">{title}</h2>

        {description && <p className="tw-text-white tw-line-clamp-3">{description}</p>}

        {ctaHref && ctaText && (
          <a
            href={ctaHref}
            className="tw-inline-block tw-border tw-border-black tw-py-3 tw-px-16"
          >
            {ctaText}
          </a>
        )}
      </div>
    </article>
  );
};

export default CalloutHero;
